// extracted by mini-css-extract-plugin
export default {"iconbutton":"iconbutton_iconbutton__jQy4D","btn-small":"iconbutton_btn-small__B04cm","btn-medium":"iconbutton_btn-medium__WYz6O","btn-large":"iconbutton_btn-large__92xWm"};